/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Task_Assigned_Fallback_BodyInputs */

const en_notifications_task_assigned_fallback_body = /** @type {(inputs: Notifications_Task_Assigned_Fallback_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A task was assigned to you.`)
};

const pt_br2_notifications_task_assigned_fallback_body = /** @type {(inputs: Notifications_Task_Assigned_Fallback_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma atividade foi atribuída a você.`)
};

/**
* | output |
* | --- |
* | "A task was assigned to you." |
*
* @param {Notifications_Task_Assigned_Fallback_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_assigned_fallback_body = /** @type {((inputs?: Notifications_Task_Assigned_Fallback_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Assigned_Fallback_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_assigned_fallback_body(inputs)
	return pt_br2_notifications_task_assigned_fallback_body(inputs)
});